import { mergeStyleSets } from '@fluentui/react';

export const calloutStyles = mergeStyleSets({
  callout: {
    width: '325px',
    minHeight: '134px',
    height: 'fit-content',
    padding: '16px 24px 16px 24px',
    fontSize: '12px',
    '& .block-ui': {
      marginTop: '45px',
    },
    '& button': {
      color: '#ffffff',
      height: '24px',
      padding: '2px 8px 2px 8px',
      borderRadius: '4px',
      backgroundColor: '#0078d4',
    },
    '& .fui-Caption1Stronger': {
      fontWeight: '600',
    },
    '& .ms-Stack': {
      marginTop: '8px',
      marginBottom: '8px',
    },
  },
  container: {},
});

export const getPanelStyles = () => ({
  '@global': {
    '.side-panel-performance-insights.panel-right .panel-content': {
      '& .panel-body': {
        width: 840,
        paddingLeft: 24,
        paddingRight: 24,
        display: 'flex',
        height: 'calc(100% - 56px)',
        overflow: 'hidden',
        marginBottom: 0,
      },
      '& .panel-header': {
        paddingLeft: 24,
      },
      '& .react-block-ui-none, .react-block-ui': {
        display: 'flex',
        height: '100%',
      },
    },
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
